import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { DropdownMenuItemStyles as styles } from './styles'

const DropdownMenuItem = ({
  id,
  title,
  href,
  isActiveItem,
  isTvGuide,
  DropdownMenuHasTitle,
  theme,
  customClassName,
  logoSrc,
  query,
  onClick,
}) => (
  <div
    key={id}
    className={[
      'DropdownMenuItem',
      theme,
      customClassName || '',
      isActiveItem && 'active',
      isActiveItem && !DropdownMenuHasTitle && 'order-top',
      isTvGuide && 'tv-guide',
    ].filter(Boolean).join(' ')}
  >
    <Link href={query} as={href} passHref legacyBehavior>
      <a className="menu-link" href={href} onClick={onClick} id={id}>
        {logoSrc ? <img src={logoSrc} alt={title} name={title} /> : title}
      </a>
    </Link>
    <style jsx>{styles}</style>
  </div>
)

DropdownMenuItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  href: PropTypes.string,
  isTvGuide: PropTypes.bool,
  isActiveItem: PropTypes.bool,
  DropdownMenuHasTitle: PropTypes.bool,
  theme: PropTypes.oneOf(['horizontal', 'vertical']),
  customClassName: PropTypes.string,
  logoSrc: PropTypes.string,
  query: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

DropdownMenuItem.defaultProps = {
  id: '',
  title: '',
  href: '',
  isTvGuide: PropTypes.bool,
  isActiveItem: false,
  DropdownMenuHasTitle: false,
  theme: 'vertical',
  customClassName: '',
  logoSrc: '',
  query: '',
}

export default DropdownMenuItem
